import { RootState } from 'store';
import { IAgencyMfaPolicy } from 'types/mfa/IAgencyMfaPolicy';

export const agencyMfaSavedSelector = (state: RootState): IAgencyMfaPolicy | null => state.agencyMfa.saved;
export const agencyMfaDraftSelector = (state: RootState): IAgencyMfaPolicy | null => state.agencyMfa.draft;
export const agencyMfaLoadingSelector = (state: RootState): boolean => state.agencyMfa.loading;
export const agencyMfaSavingSelector = (state: RootState): boolean => state.agencyMfa.saving;
export const agencyMfaErrorSelector = (state: RootState): string | null => state.agencyMfa.errorKey;
